module.exports = __webpack_public_path__ + "static/media/1jz8.c6df2834.pdb";


//////////////////
// WEBPACK FOOTER
// ./src/data/1jz8.pdb
// module id = 189
// module chunks = 0